<template>
  <div class="card shadow">
    <div class="card-header bg-transparent">
      <div>
        <h3 class="mb-0">
          {{ $tc('message.validation',1) }}
        </h3>
      </div>
    </div>
    <div :class="[ mobileView ? '' : 'card-body']">
    <b-container fluid>
      <b-row class="" style="overflow-x:auto;" v-if="!mobileView">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $tc('message.doctorName', 1) }}</th>
                <th>{{ $t('message.consultationDate') }}</th>
                <th>{{ $t('message.motif') }}</th>
                <th>{{ $t('message.patient') }}</th>
                <th>{{ $t('message.createdAt') }}</th>
                <th>{{ $tc('message.operations', 1) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(validation, index) in validation_examens" :key="index" class="mt-3">
                <td>{{ validation.consultation.author.nom.length > 40 ? validation.consultation.author.nom.substring(0, 40)+' ...' : validation.consultation.author.nom }}</td>
                <td>{{ validation.consultation.date_consultation }}</td>
                <td>{{ validation.consultation.ligne_de_temps != null ? (validation.consultation.ligne_de_temps.motif ? validation.consultation.ligne_de_temps.motif.description : null) : null }}</td>
                <td>{{ validation.consultation.dossier.patient.user.nom }}</td>
                <td>{{ new Date(validation.consultation.created_at).toLocaleString().split(",")[0] }}</td>
                <td>
                  <div v-if="validation.consultation != null">
                    <div v-if="validation.etat_validation_souscripteur == null">
                        <b-link class="btn btn-danger border-0 border-danger rounded" :to="{ name: 'consultation-general', params: { consultation: validation.consultation.slug },query:{activeTab:'examen'} }">
                            <i class="fas fa-exclamation-circle p-1"></i> Valider les examens
                        </b-link>
                    </div>
                    <div v-else>
                        <b-link class="btn btn-success border-0 border-success rounded" :to="{ name: 'consultation-general', params: { consultation: validation.consultation.slug },query:{activeTab:'view'} }">
                          <i class="fa fa-eye" aria-hidden="true" ></i>  Voir les examens 
                        </b-link>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-row>
      <b-row v-else>
                        <!-- <h3 class="card-title text-center mb-2 mt-2 title">
                            {{ $t('message.validation') }}
                        </h3> -->
             <div v-for="(validation,index) in validation_examens" :key="index" class="mt-3"> 
                    <!-- <div class=""> -->

                  <div class="list-group-item"><p class=""><span class="new-title"> {{ $tc('message.doctorName', 1) }}</span>: <span class="font-weight-bold text-gray mr-4">{{ validation.consultation.author.nom.length > 40 ? validation.consultation.author.nom.substring(0, 40)+' ...' : validation.consultation.author.nom }}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.consultationDate')}}</span>: <span class="font-weight-bold text-gray">{{validation.consultation.date_consultation}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.motif', 1)}}</span>: <span class="font-weight-bold text-gray mr-4">{{validation.consultation.ligne_de_temps != null ? (validation.consultation.ligne_de_temps.motif ? validation.consultation.ligne_de_temps.motif.description : null) : null}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="mr-2 new-title">{{ $t('message.patients')}}</span>: <span class="font-weight-bold text-gray">{{validation.consultation.dossier.patient.user.nom}}</span></p></div>
                  <div class="list-group-item"><p class=""><span class="new-title">{{ $t('message.createdAt', 1)}}</span>: <span class="font-weight-bold text-gray mr-2">{{ new Date(validation.consultation.created_at).toLocaleString().split(",")[0] }}</span></p></div>
                  <div class="list-group-item">
                    <p class="">
                      <span class="">
                        <div class="d-flex justify-content-center" v-if="validation.consultation != null">
                          <div v-if="validation.etat_validation_souscripteur == null">
                              <b-link :to="{ name: 'consultation-general', params: { consultation: validation.consultation.slug },query:{activeTab:'examen'} }">
                                  <button class="bg-danger pl--2 text-white border-0 border-danger rounded">
                                  <i class="fas fa-exclamation-circle p-2"></i> Valider les examens</button>
                              </b-link>
                          </div>
                          <div v-else>
                                <b-link :to="{ name: 'consultation-general', params: { consultation: validation.consultation.slug },query:{activeTab:'view'} }">
                                <button class="bg-success pl--2 text-white border-0 border-success rounded">
                                <i class="fa fa-eye" aria-hidden="true" ></i>  Voir les examens 
                              </button>  
                              </b-link>
                          </div>       
                        </div>
                      </span> 
                    </p>
                  </div> 
                           
          </div>
    </b-row>


    </b-container>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from  'moment';
import i18n from "@/plugins/i18n";
import _ from "lodash";
export default {
  name: "Show",
  computed: {
    ...mapGetters(["validation_examens", 'hasAdminRole',
      'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole',]),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole;
    },
    statut:function (){
      if (this.validation_examens)
        return this.validation_examens.statut;
      return null;
    },

  },
  data(){
    return {
      mobileView: true,

                fields: [
                    {
                        key: 'consultation.author.nom',
                        label: this.$i18n.tc('message.doctorName', 1),
                    },
                    {
                        key: 'consultation.date_consultation',
                        label: this.$i18n.t('message.consultationDate'),
                        sortable: true
                    },
                    {
                        key: 'consultation.ligne_de_temps.motif.description',
                        label: this.$i18n.t('message.motif'),
                    },
                    {
                        key: 'consultation.dossier.patient.user.nom',
                        label: this.$i18n.t('message.patient'),
                    },
                    {
                        key: 'consultation.created_at',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
    }
  },
  methods: {
    handleView() {
        this.mobileView = window.innerWidth <= 990;
    },
    getValidationExamens() {
      let args = {
      };
      this.$store.dispatch("getValidationExamens", {args});
    },
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'awesome') return 'table-success'
    },
    rowSelected(items) {
      this.$router.push({ name: 'consultation-general', params: { consultation: items[0].slug } });
    },    
  },
  created() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
  },

  mounted() {
    this.getValidationExamens();
  }
}
</script>

<style scoped>

</style>